import React, { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (en) => en });

function readInitialLang() {
  if (typeof window === "undefined") return "en";
  // 1. ?lang=es query (used for ads targeting)
  const params = new URLSearchParams(window.location.search);
  const q = params.get("lang");
  if (q === "es" || q === "en") return q;
  // 2. /es path prefix (also for ads / SEO)
  if (window.location.pathname.startsWith("/es")) return "es";
  // 3. localStorage
  const stored = localStorage.getItem("bb_lang");
  if (stored === "es" || stored === "en") return stored;
  return "en";
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(readInitialLang);

  const setLang = useCallback((l) => {
    setLangState(l);
    if (typeof window !== "undefined") {
      try {
        localStorage.setItem("bb_lang", l);
        document.documentElement.lang = l;
      } catch (err) { void err; }
    }
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((en, es) => (lang === "es" && es ? es : en), [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export function useLang() { return useContext(LangCtx); }
